


















import Vue from 'vue'
import Component from 'vue-class-component'
import { Getter, Action } from 'vuex-class'

import Input3InputWithUpdateButton from '../../../../../html-components-type-1-basic/basic-type-3-input/input-3-input-with-update-button.vue'
import UserInterface3ErrorMessage from '../../../../../html-components-type-1-basic/basic-type-4-user-interface/user-interface-3-error-message.vue'
import Input4PropertyIdMapper from '../../../../../html-components-type-1-basic/basic-type-3-input/input-4-property-id-mapper.vue'

import { DigitalCurrencyAccount } from '../../../../../../../../../../../service-for-game-codebase/game-codebase-type-1-app/app-type-2-digital-currency-account/digital-currency-account-type-2-data-structures/data-structures-type-1-service-data-structure/service-data-structure-1'

import { DataTableFile } from '../../../../../html-components-type-1-basic/basic-type-4-user-interface/service-for-data-structures/data-structures-1-file-system-data-structure'

const namespace = 'digitalCurrency'

@Component({
  components: {
    Input3InputWithUpdateButton,
    UserInterface3ErrorMessage,
    Input4PropertyIdMapper
  }
})
class NetworkResourceItem5NetworkPrivilegesSettings extends Vue {
  @Getter('getActiveDigitalCurrencyAccount', { namespace }) getActiveDigitalCurrencyAccount?: any
  @Getter('getDigitalCurrencyAccountSettings', { namespace }) getDigitalCurrencyAccountSettings?: any

  @Action('updateDigitalCurrencyAccountSettings', { namespace }) updateDigitalCurrencyAccountSettings?: any
  @Action('getDigitalCurrencyAccountBySearchText', { namespace }) getDigitalCurrencyAccountBySearchText?: any
  @Action('getDigitalCurrencyAccountById', { namespace }) getDigitalCurrencyAccountById?: any

  showErrorMessage: boolean = false
  errorMessage: string = 'errorMessage'

  get getBlockedAccountIdList () {
    const digitalCurrencyAccountSettings = this.getDigitalCurrencyAccountSettings(this.getActiveDigitalCurrencyAccount.accountId)
    const blockedAccountVariableTable = digitalCurrencyAccountSettings.blockedAccountVariableTable || {}
    const blockedAccountList = Object.keys(blockedAccountVariableTable).map((blockedAccountId: string) => blockedAccountId) || []
    return blockedAccountList
  }

  async getBlockedAccountList () {
    const blockedAccountIdList = this.getBlockedAccountIdList
    const blockedAccountList = []
    for (let i = 0; i < blockedAccountIdList.length; i++) {
      const digitalCurrencyAccountId = blockedAccountIdList[i]
      const digitalCurrencyAccount = await this.getDigitalCurrencyAccountById(digitalCurrencyAccountId)
      const file = new DataTableFile()
      file.itemId = digitalCurrencyAccount ? digitalCurrencyAccount.accountId : digitalCurrencyAccountId
      file.itemName = digitalCurrencyAccount ? `${digitalCurrencyAccount.accountName} (${file.itemId})` : `(Deleted) (${file.itemId})`
      file.itemIconImageUrl = digitalCurrencyAccount ? digitalCurrencyAccount.accountProfilePictureUrl : ''
      blockedAccountList.push(file)
    }

    return blockedAccountList
  }

  updateBlockedAccountVariableTable (blockedAccountIdList: string[]) {
    if (!blockedAccountIdList) {
      return
    }

    const blockedAccountVariableTable = blockedAccountIdList.reduce((map: any, obj: any, _index: number) => (map[obj] = true, map), {})

    this.updateDigitalCurrencyAccountSettings({
      propertyId: 'blockedAccountVariableTable',
      propertyValue: blockedAccountVariableTable
    }).catch((errorMessage: any) => {
      this.errorMessage = errorMessage
      this.showErrorMessage = true
    })
  }

  async searchAccount (searchText: string) {
    if (!searchText) {
      return []
    }

    let searchResultList = await this.getDigitalCurrencyAccountBySearchText({
      searchText
    })

    searchResultList = searchResultList.map((digitalCurrencyAccount: DigitalCurrencyAccount) => {
      const file = new DataTableFile()
      file.itemId = digitalCurrencyAccount.accountId
      file.itemName = `${digitalCurrencyAccount.accountName} (${file.itemId})`
      file.itemIconImageUrl = digitalCurrencyAccount.accountProfilePictureUrl
      return file
    })

    searchResultList = searchResultList.filter((fileItem: DataTableFile) => {
      return fileItem.itemId !== this.getActiveDigitalCurrencyAccount.accountId
    })

    return searchResultList
  }
}

export default NetworkResourceItem5NetworkPrivilegesSettings

